import '../../../styles/templates/account.pcss';
import '../../../styles/templates/account.rewards.pcss';

import { Toggle } from '../../ui/toggle';

const accountNavToggle = document.querySelector(
  '[data-account-nav-toggle]'
);

if (accountNavToggle) {
  new Toggle(accountNavToggle);
}
